import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// 1. Advanced Browser Support Detection
const canUseFirebaseMessaging = () => {
  // Skip if not in browser (SSR)
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
 
  // iOS Safari detection
  const isIosSafari = /iphone|ipad|ipod/i.test(navigator.userAgent) && 
                      /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  // Firefox in Private Browsing has no service worker
  const isFirefoxPrivate = navigator.userAgent.includes('Firefox') && 
                          !navigator.serviceWorker;

  // Required APIs check
  const hasRequiredApis = (
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window &&
    window.isSecureContext
  );

  return !isIosSafari && !isFirefoxPrivate && hasRequiredApis;
};

// 2. Initialize Firebase only if supported
let firebaseApp;
let messaging;

try {
  if (canUseFirebaseMessaging()) {
    firebaseApp = initializeApp({
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_FIREBASE_APP_ID,
    });

    messaging = getMessaging(firebaseApp);
  }
} catch (error) {
  console.error('Firebase initialization failed:', error);
}

// 3. Safe Token Request
export const requestForToken = async () => {
  if (!messaging) {
    console.warn('Messaging not available (unsupported browser)');
    return null;
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;

    return await getToken(messaging, {
      // testing

      vapidKey: 'BFoavn-BxVms41oSo-sb5bIYYnr_eiDc5unu2t4dIFIsRFWo0wtpQHHiivxzbYpPNPM_VhzmwgAS28n8qmM4dPI',

      // production

      // vapidKey: 'BMCFmFq9wTjb5XY-m9Io_35cjDx7iIqkeHYrPx1DhIBpCAx_56GpUOyma5zquPivx56AWWOOimPrILNRtdUu9Fc',
    
    });
  } catch (error) {
    console.error('FCM token error:', error);
    return null;
  }
};

// 4. Safe Message Listener
export const onMessageListener = () => {
  if (!messaging) {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    onMessage(messaging, (payload) => resolve(payload));
  });
};

